/**
 * Error thrown when the photo weights more than the maximum allowed
 * in the MAX_IMAGE_SIZE_IN_MB variable
 */
export class PhotoTooHeavyError extends Error {
  constructor() {
    super();
    this.name = "PhotoTooHeavyError";
  }
}
